import { React, PT, withRouter, connect, fetchApi } from '@gasbuddy/react';
import { Segment, Input, Button, Dropdown, Dimmer, Loader, Message } from 'semantic-ui-react';
import qs from 'querystring';
import { Auth, Nav, TxTable } from '../../components';
import { Role } from '../../roles';

const searchOptions = [
  { key: 'id', text: 'Account Id', value: 'id' },
  { key: 'encid', text: 'Encrypted Account Id', value: 'encid' },
  { key: 'cardname', text: 'Card Last Name', value: 'cardname' },
  { key: 'cardnumber', text: 'Card Number', value: 'cardnumber' },
];

const filterTypes = [
  { key: 'amount', text: 'Amount Is', value: 'amount' },
  { key: 'wexAmount', text: 'Wex Amount Is', value: 'wexAmount' },
  { key: 'bankAmount', text: 'Bank Amount Is', value: 'bankAmount' },
  { key: 'balance', text: 'Balance Is Not Zero', value: 'balance' },
  { key: 'authCode', text: 'Auth Code Is', value: 'authCode' },
  { key: 'extId', text: 'External Tx Id Is', value: 'extId' },
  { key: 'txDateOn', text: 'Tx Date On', value: 'txDateOn' },
  { key: 'txDateBefore', text: 'Tx Date Before', value: 'txDateBefore' },
  { key: 'txDateAfter', text: 'Tx Date After', value: 'txDateAfter' },
];

const txTypes = [
  { key: 'all', text: 'All', value: 'all' },
  { key: 'fuel', text: 'Fuel', value: 'fuel' },
  { key: 'gasback', text: 'GasBack', value: 'gasback' },
  { key: 'fees', text: 'Fee-bearing', value: 'fee' },
  { key: 'membership', text: 'Membership', value: 'membership' },
  { key: 'parking', text: 'Parking', value: 'parking' },
];

function getInitialState({ location: { search } }) {
  const state = {
    identifierType: 'id',
    txType: 'all',
    filter1Type: 'amount',
  };
  const p = Number(qs.parse(search.substring(1)).account_id);
  if (Number.isSafeInteger(p) && Number(p) >= 1) {
    state.identifier = p.toString();
  }
  return state;
}

class TransactionSearch extends React.Component {
  state = getInitialState(this.props);

  setStateField(field) {
    return (_, { value }) => {
      const stateChange = { [field]: value };
      this.setState(stateChange);
    };
  }

  callApi = () => {
    const { identifier, identifierType, filter1Type, filter1Value, txType } = this.state;
    this.setState({ loading: true }, async () => {
      const { body, status, error } = await fetchApi({
        url: '/payments/transactions/search',
        catchErrors: true,
        body: { identifier, identifierType, filter1Type, filter1Value, txType },
      });
      if (error || status !== 200) {
        this.setState({ error: body || error, loading: false });
      } else {
        this.setState({ transactions: body.transactions, loading: false });
      }
    });
  }

  render() {
    const { identifier, loading, transactions, error } = this.state;

    return (
      <Auth forRoles={[Role.Superuser, Role.PaymentView]}>
        <Nav>
          <div>
            {error && (
              <Message error>
                Unable to run the search.
                <pre>{JSON.stringify(error, null, '\t')}</pre>
              </Message>
            )}
            <Segment>
              <div>
                <span style={{ marginRight: 10 }}>Find</span>
                <Dropdown
                  inline
                  options={txTypes}
                  defaultValue="all"
                  onChange={this.setStateField('txType')}
                />
                <span style={{ marginRight: 10 }}>transactions by</span>
                <Dropdown
                  inline
                  options={searchOptions}
                  defaultValue="id"
                  onChange={this.setStateField('identifierType')}
                />
                <Input
                  onChange={this.setStateField('identifier')}
                  defaultValue={identifier}
                />
                <span style={{ marginLeft: 10, marginRight: 10 }}>where</span>
                <Dropdown
                  inline
                  options={filterTypes}
                  defaultValue="amount"
                  onChange={this.setStateField('filter1Type')}
                />
                <Input
                  onChange={this.setStateField('filter1Value')}
                />
              </div>
              <div style={{ textAlign: 'right', marginTop: 5 }}>
                <Button primary onClick={this.callApi}>Search</Button>
              </div>
            </Segment>
            <Dimmer.Dimmable dimmed={loading}>
              <Dimmer active={loading}>
                <Loader />
              </Dimmer>
              <TxTable
                tx={transactions}
              />
            </Dimmer.Dimmable>
          </div>
        </Nav>
      </Auth>
    );
  }
}

TransactionSearch.propTypes = {
  history: PT.shape({ push: PT.func.isRequired }).isRequired,
  match: PT.shape({
    params: PT.shape({ accountId: PT.string }),
  }).isRequired,
};

TransactionSearch.defaultProps = {
};

export default withRouter(connect(({ users }) => ({ users }))(TransactionSearch));
